import { render, staticRenderFns } from "./RightCertificacoes.vue?vue&type=template&id=af2849ba"
import script from "./RightCertificacoes.vue?vue&type=script&lang=js"
export * from "./RightCertificacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports